import React from "react";
import { Box, Paper, Typography, Chip, CircularProgress } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const getDaysStyle = (days) => {
  if (days >= 75) return { bgcolor: "#FEE2E2", color: "#DC2626" };
  if (days >= 50) return { bgcolor: "#FFEDD5", color: "#EA580C" };
  return { bgcolor: "#FEF9C3", color: "#CA8A04" };
};

const AgingJobsAlerts = ({ data, loading }) => {
  return (
    <Box
      sx={{
        bgcolor: "#FFFBEB",
        borderRadius: 2,
        overflow: "hidden",
        height: 420,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 2.5, pt: 2.5, pb: 1.5 }}>
        <WarningAmberIcon sx={{ color: "#F59E0B", fontSize: 22 }} />
        <Typography variant="h6" fontWeight={700} color="text.primary">
          Aging Jobs Alerts{data && data.length > 0 ? ` (${data.length})` : ""}
        </Typography>
      </Box>

      {/* Items */}
      <Box sx={{ flex: 1, px: 1.5, pb: 1.5, display: "flex", flexDirection: "column", gap: 1, overflowY: "auto", maxHeight: 316 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 160 }}>
            <CircularProgress sx={{ color: "#F59E0B" }} />
          </Box>
        ) : !data || data.length === 0 ? (
          <Box sx={{ p: 3, textAlign: "center" }}>
            <Typography color="text.secondary">No aging jobs to show.</Typography>
          </Box>
        ) : (
          data.map((row) => {
            const style = getDaysStyle(row.daysActive);
            return (
              <Paper
                key={row.job_id}
                elevation={0}
                sx={{ bgcolor: "#fff", borderRadius: 1.5, p: 1.75, border: "1px solid #F3F4F6" }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
                  <Typography variant="caption" sx={{ color: "#9CA3AF", fontWeight: 500, letterSpacing: "0.02em" }}>
                    {row.job_code || "—"}
                  </Typography>
                  <Chip
                    label={`${row.daysActive} DAYS`}
                    size="small"
                    sx={{
                      bgcolor: style.bgcolor,
                      color: style.color,
                      fontWeight: 700,
                      fontSize: "10px",
                      height: 22,
                      borderRadius: "6px",
                    }}
                  />
                </Box>
                <Typography fontWeight={700} fontSize={15} color="text.primary" lineHeight={1.3}>
                  {row.title || "—"}
                </Typography>
                <Typography variant="caption" color="text.secondary" mt={0.25} display="block">
                  HM: {row.hmName || "—"}
                </Typography>
              </Paper>
            );
          })
        )}
      </Box>
    </Box>
  );
};

export default AgingJobsAlerts;
